import React, { createContext, useContext, useMemo, useState, useCallback, useEffect } from "react";
import { applyThemeMode, getEffectiveThemeMode, persistThemeMode } from "./themeMode.js";

const ThemeModeContext = createContext({ mode: "light", toggleThemeMode: () => {}, setThemeMode: () => {} });

export const useThemeMode = () => useContext(ThemeModeContext);

// Porte les deux thèmes clair et sombre de Rise-T, sur une base 100% Tailwind :
// aucune dépendance à un thème MUI. Les couleurs vivent dans src/style/tokens.css
// (variables CSS lues par tailwind.config.js), ce fournisseur ne fait que basculer
// l'attribut data-theme et mémoriser le choix.
export const ThemeModeProvider = ({ children }) => {
  const [mode, setMode] = useState(getEffectiveThemeMode);

  // Le script inline de public/index.html a déjà posé data-theme avant le premier
  // rendu (pas de flash) ; on le réaligne ici au cas où React a démarré avec un
  // état différent (hydratation, StrictMode double-rendu).
  useEffect(() => {
    applyThemeMode(mode);
  }, [mode]);

  const setThemeMode = useCallback((nouveauMode) => {
    persistThemeMode(nouveauMode);
    setMode(nouveauMode);
  }, []);

  const toggleThemeMode = useCallback(() => {
    setMode((modePrecedent) => {
      const modeSuivant = modePrecedent === "dark" ? "light" : "dark";
      persistThemeMode(modeSuivant);
      return modeSuivant;
    });
  }, []);

  const valeur = useMemo(() => ({ mode, toggleThemeMode, setThemeMode }), [mode, toggleThemeMode, setThemeMode]);

  return <ThemeModeContext.Provider value={valeur}>{children}</ThemeModeContext.Provider>;
};
